/* eslint-disable import/prefer-default-export */
import qs from 'qs';

export function getCookie(name) {
  let arr;
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
  // eslint-disable-next-line no-cond-assign
  if (arr = document.cookie.match(reg)) {
    return unescape(arr[2]);
  } else {
    return null;
  }
}

// 获取count: 7天 的日期范围
export function getCountTime(count) {
  // 获取近多少天的日期
  const time1 = new Date();
  time1.setTime(time1.getTime());
  const Y1 = time1.getFullYear();
  const M1 =
    time1.getMonth() + 1 >= 10
      ? time1.getMonth() + 1
      : `0${time1.getMonth() + 1}`;
  const D1 =
    time1.getDate() >= 10 ? time1.getDate() : `0${time1.getDate()}`;
  const timer1 = `${Y1}-${M1}-${D1}`; // 当前时间
  const time2 = new Date();
  time2.setTime(time2.getTime() - 24 * 60 * 60 * 1000 * count);
  const Y2 = time2.getFullYear();
  const M2 =
    time2.getMonth() + 1 >= 10
      ? time2.getMonth() + 1
      : `0${time2.getMonth() + 1}`;
  const D2 =
    time2.getDate() >= 10 ? time2.getDate() : `0${time2.getDate()}`;
  const timer2 = `${Y2}-${M2}-${D2}`; // 之前的7天或者30天
  return {
    t1: timer1,
    t2: timer2,
  };
}

// 复制
export function copyText(text) {
  const input = document.createElement('input');
  document.body.appendChild(input);
  input.value = text; // 修改文本框的内容
  input.select(); // 选中文本
  document.execCommand('copy'); // 执行浏览器复制命令
  document.body.removeChild(input);
  return Promise.resolve(1);
}

export function exportExcel({ url = '', params = {} }) {
  try {
    // 兼容不走Axios的情况
    if (!params.corpCode) {
      params.corpCode = getCookie('pub_corp_code') || '';
    }
    window.location = `${url}?${qs.stringify(params)}`;
    return Promise.resolve();
  } catch (err) {
    return Promise.reject(err);
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@sditest/electronic-invoice-api/src/utils/tools.js
// module id = pFJ1
// module chunks = 70